import React from 'react';
import { useNavigate } from 'react-router-dom';
import BoxType2 from './BoxType2';
import { FaVideo } from 'react-icons/fa';
import { Space, Button } from 'antd';
import VideoItem from '../../Videos/Components/VideoItem';

//import PropTypes from 'prop-types';

const SectionVideos = () => {
  const navigate = useNavigate();

  const title = (
    <Space className='btn'>
      <FaVideo />
      Videos
    </Space>
  );

  return (
    <BoxType2
      title={title}
      extras2={
        <Button
          onClick={() => {
            navigate('/videos');
          }}>
          <Space className='btn'>
            <FaVideo />
            See all videos
          </Space>
        </Button>
      }>
      <div className='flex flex-row flex-wrap gap-12'>
        <VideoItem videoId='17f97945-aa1b-4aaf-a2de-c3bb7d90bb2a' title='Data Privacy Demo' description='Leveraging Genesys Cloud Privacy and Security features to personalize experiences whilst avoiding sensitive data storage.' thumbnail='/images/thumbnails/thumbnail-data-privacy-demo.png' />
        <VideoItem videoId='27f97945-aa1b-4aaf-a2de-c3bb7d90bb2a' title='Operational Event Notifications & Monitoring' description='How to monitor events and notifications in Genesys Cloud to ensure compliance with data privacy regulations.' thumbnail='/images/thumbnails/thumbnail-operational-event-notifications-and-monitoring.png' />
        <VideoItem videoId='37f97945-aa1b-4aaf-a2de-c3bb7d90bb2a' title='Operational Status and Incidents' description='How to check the operational status of Genesys Cloud and receive notifications about incidents.' thumbnail='/images/thumbnails/thumbnail-operational-status-and-incidents.png' />
      </div>
    </BoxType2>
  );
};

SectionVideos.propTypes = {};

export default SectionVideos;
